import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box mb-3"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "midTitle" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "opTableScroller" }
const _hoisted_6 = { class: "opTable table table-striped" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Prenotazioni",
              text: "Prenotazioni"
            })
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.bookingVouchers.length == 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bookWithVoucher && _ctx.bookWithVoucher(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nuova prenotazione",
              text: "Nuova prenotazione"
            }),
            _cache[1] || (_cache[1] = _createTextVNode(" (")),
            _createVNode(_component_localized_text, {
              localizedKey: "Ticket rimasti: {{ticket}}",
              text: "Ticket rimasti: {{ticket}}",
              object: { ticket: _ctx.bookingVouchers.length }
            }, null, 8, ["object"]),
            _cache[2] || (_cache[2] = _createTextVNode(") "))
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Progetto",
                    text: "Progetto"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Tipo",
                    text: "Tipo"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Data",
                    text: "Data"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Orario",
                    text: "Orario"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Stato",
                    text: "Stato"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dottore",
                    text: "Dottore"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Professione",
                    text: "Professione"
                  })
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookings, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(item.project), 1),
                  _createElementVNode("td", null, _toDisplayString(item.visitType), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.data, 'DD-MM-YYYY HH:mm')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.from)) + " - " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.to)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.stato.value), 1),
                  _createElementVNode("td", null, _toDisplayString(item.user && item.user.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.professione && item.professione.name), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      class: "btn btn-primary",
                      to: '/bookingDetail/' + item.identifier
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Dettaglio",
                          text: "Dettaglio"
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (item.stato.value == 'In attesa')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-warning ms-2",
                          onClick: ($event: any) => (_ctx.modifyBooking(item))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Sposta",
                            text: "Sposta"
                          })
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}